import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheck,
    faCircle,
    faCog,
    faDownload,
    faEraser,
    faEyeDropper,
    faFile,
    faFill, faFolder,
    faFont,
    faMinus, faPrint,
    faSave,
    faSquare,
    faTimes,
    faTrash
} from '@fortawesome/free-solid-svg-icons'
import { faCircle as farCircle } from '@fortawesome/free-regular-svg-icons'

export function setupIcons (): void {
    library.add(faSave, faDownload, faFill, faCircle, faEyeDropper, faSquare, faFill, faMinus, faEraser, farCircle, faFile, faFont, faTimes, faCheck, faTrash, faCog, faFolder, faPrint)
}
